import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getDetails } from "services/redux/sales/preSaleListing/action"
import ViewLeadV2 from "./viewLeadV2";

const mapStateToProps = (state) => ({
  viewDetails: state.preSalesListReducer.viewDetails
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewLeadV2);
